import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Signbutton, { Debtbutton } from "../../forms/button";
import {
  validateSubBroker,
  getNewPurchaseFundList,
  getOtherSchemes,
  getAssetClasses,
  setSwitchDetails,
  getRedemptionPaymentDetails,
  switchTransaction,
  addItemsToCart,
  getCartItemsList,
} from "../../../store/actions";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import {
  YES,
  PARTIAL,
  FULL,
  UNITS,
  AMOUNT,
  REGULAR,
  PURCHASE,
  SWITCH,
  singleTransaction,
} from "../../../store/types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import moment from "moment";
import { NEW_TRANSACTION_URL } from ".";
import { AddToCartStatusModal } from "../customModal";
import { SUBMIT, addToCart } from "../../../store/types";
import { handleError } from "../../../utils/cart";
class switchCmponent extends Component {
  constructor(props) {
    super(props);
    const { fundList } = this.props;
    const { switchDetails } = this.props;
    const funds = fundList.reduce((prev, curr) => {
      if (curr.sFlag === YES) {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [
            ...prev,
            {
              Fund: curr.Fund,
              FundDesc: curr.FundDesc,
              opt: curr.Opt,
              SchType: curr.SchType,
            },
          ];
        }
      }
      return prev;
    }, []);
    this.state = {
      funds,
      openDialog: false,
      fund: { value: "" },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      radioValue: { value: "yes" },
      arnCode: { value: this.props.token },
      subArnCode: { value: "" },
      subBrokerCode: { value: "" },
      euinNo: { value: "" },
      category: { value: "" },
      categories: [],
      switchInSchemes: [],
      switchInScheme: { value: "" },
      amount: { value: "" },
      switchType: PARTIAL,
      switchMode: UNITS,
      PosterOpen: false,
      openeuin: true,
      erroreuin: false,
      ...switchDetails,
    };
  }

  handleFundChange = (value) => {
    // if(!!value && !!value.value && (String(value.value).trim() === "176" || String(value.value).trim() === "103")){
    //   this.setState({
    //     PosterOpen:true
    //   })
    // }
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        folio: { value: "" },
        scheme: { value: "" },
        amount: { value: "" },
        switchInScheme: { value: "" },
        category: { value: "" },
      });
      return;
    } else if (
      !!value &&
      !!this.state.fund &&
      value.value === this.state.fund.value.value
    ) {
      return;
    } else {
      const fund = value.value;
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.Fund === fund && curr.sSchFlg === YES) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        folio: { value: "" },
        scheme: { value: "" },
        category: { value: "" },
        switchInScheme: { value: "" },
        switchType: PARTIAL,
        switchMode: UNITS,
      });
      if (!!fund) {
        this.validateBrokerCode(fund)();
      }
    }
  };
  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  validateBrokerCode = (fund) => async () => {
    const { subArnCode, arnCode } = this.state;
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }
    const params = {
      Fund: fund,
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    const response = await this.props.validateSubBroker(params);
    if (!response) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `Please enter a valid Sub ARN Code`,
        },
      });
    }
  };

  handleFolioChange = async (value) => {
    if (!value) {
      this.setState({
        folio: { value: "" },
        schemes: [],
        scheme: { value: "" },
        category: { value: "" },
        switchInScheme: { value: "" },
        switchType: PARTIAL,
        switchMode: UNITS,
        amount: { value: "" },
      });
      return;
    } else if (
      !!value &&
      !!this.state.folio &&
      value.value === this.state.folio.value.value
    ) {
      return;
    } else {
      const folio = value.value;
      const schemes = this.schemes(folio);

      this.setState({
        folio: {
          value,
          isError: !schemes.length,
          errorMessage: !schemes.length
            ? "SWITCH in zero balance folios is not allowed"
            : "",
        },
        schemes,
        scheme: { value: "" },
        category: { value: "" },
        switchInScheme: { value: "" },
        switchType: PARTIAL,
        switchMode: UNITS,
        categories: [],
      });

      this.getAssetClasses();
    }
  };
  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.sSchFlg === YES &&
        curr.Fund === this.state.fund.value.value &&
        curr.Acno === folio &&
        !!curr.BalUnits
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };
  handleSchemeChange = (value) => {
    if (!value) {
      this.setState({
        scheme: { value: "" },
        minAmount: "",
        amount: { value: "" },
        category: { value: "" },
        switchInScheme: { value: "" },
        switchType: PARTIAL,
        switchMode: UNITS,
        categories: [],
      });
      return;
    } else if (
      !!value.value &&
      !!this.state.scheme.value.value &&
      value.value.SchDesc === this.state.scheme.value.value.SchDesc
    ) {
      return;
    } else {
      const scheme = value.value;
      if (!!value.value && !value.value.BalUnits) {
        this.setState({
          folio: {
            value: "",
            isError: "true",
            errorMessage: "Switch in Zero balance folios is not accepted",
          },
          scheme: { value: "" },
        });
      } else {
        this.setState({
          scheme: { value },
          minAmount: !!scheme ? scheme.MinAmt : "",
          amount: { value: "" },
          category: { value: "" },
          switchInScheme: { value: "" },
        });
      }
      this.getAssetClasses();
    }
  };
  handleCategoryChange = (event) => {
    if (!!event.target.value) {
      this.getOtherSchemes(event.target.value);
      this.setState({
        category: { value: event.target.value },
        switchInScheme: { value: "" },
        switchInSchemes: [],
      });
    }
    // else if(event.target.value===){

    // }
    else {
      this.setState({
        category: { value: "" },
        switchInScheme: { value: "" },
        switchInSchemes: [],
      });
    }
  };
  getAssetClasses = async () => {
    const params = {
      Fund: this.state.fund.value.value,
      Folio: this.state.folio.value.value,
    };
    const assetClasses = await this.props.getAssetClasses(params);
    if (assetClasses) {
      this.setState({
        categories: assetClasses.DtData,
      });
    }
  };

  changeEuin = (value) => {
    this.setState({
      euinNo: { value },
    });
  };

  getOtherSchemes = async (value) => {
    const params = {
      schtype: REGULAR,
      category: value,
      acno: this.state.folio.value.value,
      fundCode: this.state.fund.value.value,
      trantype: "S",
    };
    console.log(params, "sdlfkjsdl");
    const otherSchemes = await this.props.getOtherSchemes(params);
    if (otherSchemes) {
      this.setState({
        switchInSchemes: otherSchemes.DtData.filter(
          ({ fm_scheme, fm_option, fm_plan }) =>
            fm_option !== this.state.scheme.value.value.Opt ||
            fm_scheme !== this.state.scheme.value.value.Sch ||
            fm_plan !== this.state.scheme.value.value.Pln
        ),
      });
    }
  };
  handleSwitchInSchemeChange = (value) => {
    if (!value) {
      this.setState({
        switchInScheme: { value },
      });
      return;
    }
    this.setState({
      switchInScheme: { value },
    });
  };
  changeValue = (label) => (event) => {
    if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
    if (label === "radioValue" && event.target.value === "no") {
      this.setState({
        radioValue: { value: event.target.value },
      });
    }
    if (label === "radioValue" && event.target.value === "yes") {
      this.setState({
        [label]: { value: event.target.value },
        euinNo: { value: "" },
      });
    } else if (
      label !== "subArnCode" &&
      label !== "subBrokerCode" &&
      label === "radioValue" &&
      event.target.value !== "no"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  handleSwitchValueChange(event) {
    if (event.target.value.length <= 10) {
      this.setState({
        amount: {
          value: event.target.value,
        },
      });
    }
  }

  changeSwitchType = (value) => () => {
    if (value === FULL) {
      this.setState({
        switchType: FULL,
        switchMode: UNITS,
        amount: {
          value: !!this.state.scheme.value
            ? this.state.scheme.value.value.BalUnits
            : "",
        },
      });
    }
    if (value === PARTIAL) {
      this.setState({
        switchType: PARTIAL,
        amount: { value: "" },
      });
    }
  };
  changeSwitchMode = (value) => () => {
    if (value === AMOUNT) {
      this.setState({
        switchMode: AMOUNT,
        amount: { value: "" },
      });
    }
    if (value === UNITS) {
      this.setState({
        switchMode: UNITS,
        amount: { value: "" },
      });
    }
  };
  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;

    const { switchMode, scheme } = this.state;
    if (!!this.state.scheme && !!this.state.scheme.value.value) {
      if (label === "amount") {
        return;
      }
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  euinitem = (item) => {
    this.setState({
      euinNo: { value: item.abm_agent, key: item.abm_name },
      openeuin: false,
    });
  };
  submit = async () => {
    let currValue, currAmountValue;
    const {
      funds,
      openDialog,
      erroreuin,
      openeuin,
      schemes,
      switchInSchemes,
      PosterOpen,
      folios,
      switchType,
      switchMode,
      minAmount,
      categories,
      arnCode,
      subArnCode,
      subBrokerCode,
      euinNo,
      amount,
      radioValue,
      isError,
      errorMessage,
      ...others
    } = this.state;
    if (this.state.amount.value === "") {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `(Please enter the switch value)`,
        },
      });
    }
    if (radioValue.value === "yes" && !euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
        },
        erroreuin: true,
      });
      return;
    }
    const arn = this.state.arnCode.value.split("-");
    const keys = Object.keys(others);
    if (!!this.state.scheme.value) {
      currValue = parseFloat(
        this.state.scheme.value.value.CurValue.replace(/,/g, "")
      );
      currValue = currValue * (1 + 0.05);
    }
    currAmountValue =
      this.state.switchType !== FULL
        ? parseFloat(this.state.amount.value.replace(/,/g, ""))
        : "";
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${key} is Mandatory* `,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.switchOutField.focus();
          break;
        }
        case "category": {
          this.category.focus();
          break;
        }
        case "switchInScheme": {
          this.switchInScheme.focus();
          break;
        }
      }
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should  not match `,
        },
      });
    } else if (
      (this.state.scheme.value.value.MinAmt >
        parseFloat(this.state.amount.value) * (1 + 0.05) &&
        this.state.switchMode === AMOUNT) ||
      (this.state.scheme.value.value.BalUnits < this.state.amount.value &&
        this.state.switchMode === UNITS &&
        this.state.switchType === PARTIAL) ||
      (currValue < currAmountValue && this.state.switchMode === AMOUNT)
    ) {
      if (
        currValue < currAmountValue &&
        this.state.scheme.value.value.MinAmt < this.state.amount.value
      ) {
        this.setState({
          amount: {
            ...others["amount"],
            isError: true,
            errorMessage: `(You dont have enough amount to Switch Plan)`,
          },
        });
      } else if (
        this.state.scheme.value.value.MinAmt > this.state.amount.value &&
        this.state.switchMode === AMOUNT
      ) {
        this.setState({
          amount: {
            ...others["amount"],
            isError: true,
            errorMessage: `(Amount value is ${this.state.minAmount})`,
          },
        });
        this.amountField.focus();
        return;
      } else if (
        this.state.scheme.value.value.BalUnits < this.state.amount.value &&
        this.state.switchMode === UNITS
      ) {
        this.setState({
          ...others["amount"],
          isError: true,
          errorMessage: `You dont have enough Units to Switch Plan`,
        });
      }
      this.amountField.focus();
      return;
    } else {
      this.props.setSwitchDetails(this.state);
      const params = {
        amount: switchMode === AMOUNT ? this.state.amount.value : "0",
        fund: others.fund.value.value,
        plan: others.scheme.value.value.Pln,
        scheme: others.scheme.value.value.Sch,
        acno: others.scheme.value.value.Acno,
        trdt: moment(new Date()).format("MM/DD/YYYY"),
        units: switchMode === UNITS ? this.state.amount.value : "0",
        ttrtype: PURCHASE,
      };
      const response = await this.props.getRedemptionPaymentDetails(params);
      if (response) {
        this.props.history.push({
          pathname: NEW_TRANSACTION_URL + "/switch/digital/transact/confirm",
          state: {
            title: "switch Payment Summary",
            type: SWITCH,
            scheme: others.scheme.value.value,
            Folio: { value: others.scheme.value.value.Acno },
            switchInScheme: others.switchInScheme.value.value,
            fund: others.fund.value.value,
            switchMode,
            subArnCode: this.state.subArnCode.value,
            subBrokerCode: this.state.subBrokerCode.value,
            switchType,
            euin: this.state.euinNo.value,
            amount: this.state.amount.value,
          },
        });
      }
    }
  };

  onButtonClick = async (btnLabel) => {
    try {
      let currValue, currAmountValue;
      const {
        funds,
        openDialog,
        erroreuin,
        openeuin,
        schemes,
        switchInSchemes,
        PosterOpen,
        folios,
        switchType,
        switchMode,
        minAmount,
        categories,
        arnCode,
        subArnCode,
        subBrokerCode,
        euinNo,
        // amount,
        radioValue,
        isError,
        errorMessage,
        cartId,
        ...others
      } = this.state;
      // if (this.state.amount.value === "") {
      //   this.setState({
      //     amount: {
      //       value: "",
      //       isError: true,
      //       errorMessage: `(Please enter the switch value)`,
      //     },
      //   });
      // }
      if (radioValue.value === "yes" && !euinNo.value) {
        this.setState({
          euinNo: {
            value: "",
          },
          erroreuin: true,
        });
        return;
      }
      const arn = this.state.arnCode.value.split("-");
      const keys = Object.keys(others);
      if (!!this.state.scheme.value) {
        currValue = parseFloat(
          this.state.scheme.value.value.CurValue.replace(/,/g, "")
        );
      }
      currAmountValue =
        this.state.switchType !== FULL
          ? parseFloat(String(this.state.amount.value).replace(/,/g, ""))
          : "";
      const findError = keys.every((key) => !!others[key].value);
      if (!findError) {
        keys.forEach((key) => {
          !others[key].value &&
            this.setState({
              [key]: {
                ...others[key],
                isError: true,
                errorMessage:
                  this.state.switchMode === UNITS && key === "amount"
                    ? "Units are mandatory*"
                    : `${
                        key[0].toUpperCase() + key.substring(1)
                      } is Mandatory*`,
                // errorMessage: `${key} is Mandatory* `,
              },
            });
        });
        const firstErroredKey = keys.find((key) => !others[key].value);
        switch (firstErroredKey) {
          case "fund": {
            this.fundField.focus();
            break;
          }
          case "folio": {
            this.folioField.focus();
            break;
          }
          case "scheme": {
            this.switchOutField.focus();
            break;
          }
          case "category": {
            this.category.focus();
            break;
          }
          case "switchInScheme": {
            this.switchInScheme.focus();
            break;
          }
        }
        return;
      }

      if (this.state.switchMode === AMOUNT) {
        const minimumAmount = parseFloat(
          this.state.switchInScheme.value.value.SIPminamt
        );
        const availableBalance = currValue;
        const enteredAmount = parseFloat(this.state.amount.value);

        if (availableBalance > minimumAmount && enteredAmount < minimumAmount) {
          this.setState({
            amount: {
              value: enteredAmount,
              isError: true,
              errorMessage: `Switch In minimum amount should be ${minimumAmount}`,
            },
          });
          return;
        }
        if (
          availableBalance < minimumAmount &&
          enteredAmount * (1 + 0.05) < minimumAmount
        ) {
          this.setState({
            amount: {
              value: enteredAmount,
              isError: true,
              errorMessage: `You do not have enough amount to switch`,
            },
          });
          return;
        }

        if (enteredAmount > availableBalance) {
          this.setState({
            amount: {
              value: enteredAmount,
              isError: true,
              errorMessage: `You do not have enough amount to switch`,
            },
          });
          return;
        }
      }

      if (arn[1] === this.state.subArnCode.value) {
        this.setState({
          subArnCode: {
            value: "",
            isError: true,
            errorMessage: `and ARN code should  not match `,
          },
        });
      } else if (
        this.state.scheme.value.value.BalUnits < this.state.amount.value &&
        this.state.switchMode === UNITS &&
        this.state.switchType === PARTIAL
      ) {
        if (
          currValue < parseFloat(currAmountValue) &&
          this.state.switchInScheme.value.value.SIPminamt <
            this.state.amount.value
        ) {
          this.setState({
            amount: {
              ...others["amount"],
              isError: true,
              errorMessage: `(You dont have enough units to Switch Plan)`,
            },
          });
        } else if (
          this.state.switchInScheme.value.value.SIPminamt >
            parseFloat(this.state.amount.value) * (1 + 0.05) &&
          this.state.switchMode === AMOUNT
        ) {
          this.setState({
            amount: {
              ...others["amount"],
              isError: true,
              errorMessage: `Switch In minimum amount should be ${this.state.switchInScheme.value.value.SIPminamt}`,
            },
          });
          this.amountField.focus();
          return;
        } else if (
          this.state.scheme.value.value.BalUnits < this.state.amount.value &&
          this.state.switchMode === UNITS
        ) {
          this.setState({
            amount: {
              ...others["amount"],
              isError: true,
              errorMessage: `You dont have enough Units to Switch Plan`,
            },
          });
        }
        this.amountField.focus();
        return;
      } else {
        this.props.setSwitchDetails(this.state);

        const { communicationDetails, investorData } = this.props;
        const Xmobile = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.Mobile
        );
        const Xemail = communicationDetails.find(
          (detail) =>
            detail.Fund === this.state.fund.value.value &&
            detail.Acno === this.state.folio.value.value &&
            detail.PAN === investorData.PAN &&
            !!detail.email
        );

        const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
        const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
        const selectedFund = funds.find(
          (i) => i.Fund === others.fund.value.value
        ).FundDesc;

        const params = {
          pan: this.props.investorData.PAN,
          mobile: Mobile,
          email: Email,
          folio: others.scheme.value.value.Acno,
          fund: others.fund.value.value,
          scheme: others.scheme.value.value.Sch,
          plan: others.scheme.value.value.Pln,
          option: others.scheme.value.value.Opt,
          toScheme: others.switchInScheme.value.value.fm_scheme,
          toPlan: others.switchInScheme.value.value.fm_plan,
          toOption: others.switchInScheme.value.value.fm_option,
          amount: switchMode === AMOUNT ? this.state.amount.value : "0",
          units: switchMode === UNITS ? this.state.amount.value : "0",
          arn: this.state.arnCode.value,
          category: this.state.category.value,
          subArn: !!this.state.subArnCode.value ? subArnCode.value : "",
          subBroker: this.state.subBrokerCode.value,
          euin:
            this.state.radioValue.value === "yes" ? this.state.euinNo.key : "",
          euinDeclaration: this.state.radioValue.value === "no" ? "Y" : "N",
          partial: switchType === PARTIAL ? true : false,
          transactionType: singleTransaction.SWITCH,
          userId: this.state.arnCode.value, //this.props.userId,
          dcr: singleTransaction.DCR, //Imp
          arnCode: this.state.arnCode.value,
          investorName: this.props.investorData.invname,
          switchOutSchemeName: this.state.scheme.value.label,
          switchInSchemeName: this.state.switchInScheme.value.label,
          taxSaverFlag: others.scheme.value.value.TaxSaverFlag,
          fundName: selectedFund,
        };
        if (btnLabel === SUBMIT) {
          const response = await this.props.switchTransaction(params);
          if (response) {
            this.props.history.goBack();
          }
        } else if (btnLabel === addToCart) {
          const response = await this.props.addItemsToCart(params);
          if (response) {
            const [newCartItem] = response.cartItems.sort(
              (item1, item2) =>
                Number(item2.cartItemId) - Number(item1.cartItemId)
            );
            this.setState({
              openDialog: true,
              cartId: response.bulkOrderId,
              ihno: newCartItem.ihno,
            });
          }
        }
        // const params = {
        //   amount: switchMode === AMOUNT ? this.state.amount.value : "0",
        //   fund: others.fund.value.value,
        //   plan: others.scheme.value.value.Pln,
        //   scheme: others.scheme.value.value.Sch,
        //   acno: others.scheme.value.value.Acno,
        //   trdt: moment(new Date()).format("MM/DD/YYYY"),
        //   units: switchMode === UNITS ? this.state.amount.value : "0",
        //   ttrtype: PURCHASE,
        // };
        // const response = await this.props.getRedemptionPaymentDetails(params);
        // if (response) {
        //   this.props.history.push({
        //     pathname: NEW_TRANSACTION_URL + "/switch/digital/transact/confirm",
        //     state: {
        //       title: "switch Payment Summary",
        //       type: SWITCH,
        //       scheme: others.scheme.value.value,
        //       Folio: { value: others.scheme.value.value.Acno },
        //       switchInScheme: others.switchInScheme.value.value,
        //       fund: others.fund.value.value,
        //       switchMode,
        //       subArnCode: this.state.subArnCode.value,
        //       subBrokerCode: this.state.subBrokerCode.value,
        //       switchType,
        //       euin: this.state.euinNo.value,
        //       amount: this.state.amount.value,
        //     },
        //   });
        // }
      }
    } catch (error) {
      handleError(error);
    }
  };

  addTocart = () => {
    this.setState({ openDialog: true });
  };

  close = () => {
    this.setState({ openDialog: false });
  };

  render() {
    const {
      fund,
      funds = [],
      folio,
      folios = [],
      schemes = [],
      scheme,
      radioValue,
      arnCode,
      subArnCode,
      subBrokerCode,
      euinNo,
      categories,
      category,
      switchInScheme,
      switchInSchemes,
      amount,
      switchType,
      switchMode,
    } = this.state;
    const { euinList } = this.props;
    const checkMultiBrokerFlag =
      !!this.state.scheme &&
      !!this.state.scheme.value &&
      !!this.state.scheme.value.value &&
      !!this.state.scheme.value.value.multibrokflg &&
      this.state.scheme.value.value.multibrokflg === "Y";
    return (
      <div className="transaction-details">
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <div className="title">Switch</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">AMC</div>
          <IntegrationReactSelect
            suggestions={funds.map((item) => ({
              label: item.FundDesc,
              value: item.Fund,
            }))}
            label="AMC"
            value={fund.value}
            placeholder="Select AMC"
            handleChange={this.handleFundChange}
            inputRef={(ele) => (this.fundField = ele)}
            isError={fund.isError}
            errorMessage={fund.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            disabled={!fund.value}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">
            Switch out Scheme
          </div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              value: item,
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            disabled={!folio.value}
            inputRef={(ele) => (this.switchOutField = ele)}
            isError={scheme.isError}
            errorMessage={scheme.errorMessage}
          />
        </div>
        <div className="redemption-details">
          <div className="keys">
            {!checkMultiBrokerFlag && <div>Balance Units</div>}
            {!checkMultiBrokerFlag && <div>Current Value</div>}
            <div>NAV as on Date</div>
          </div>
          <div className="values">
            {!checkMultiBrokerFlag && (
              <div>
                {!!scheme && !!scheme.value ? scheme.value.value.BalUnits : ""}
              </div>
            )}
            {!checkMultiBrokerFlag && (
              <div>
                {!!scheme && !!scheme.value ? scheme.value.value.CurValue : ""}
              </div>
            )}
            <div>
              {!!scheme && !!scheme.value ? scheme.value.value.LastNAV : ""}
            </div>
          </div>
        </div>
        {!!checkMultiBrokerFlag && (
          <div
            style={{
              fontFamily: "OpenSans-SemiBold",
              fontSize: 13,
              color: "red",
              margin: 10,
            }}
          >
            {" "}
            Note: This folio has multiple distributors. Hence, the balance units
            and current value will not be displayed.
          </div>
        )}
        <div className="input-margin">
          <CustomizedSelect
            placeholder="Select Category"
            name="Category"
            borderColor="#a6a6a6"
            handleChange={this.handleCategoryChange}
            value={category.value}
            inputRef={(ele) => (this.category = ele)}
            isError={category.isError}
            disabled={!scheme.value}
            errorMessage={category.errorMessage}
          >
            {categories.map((item, index) => (
              <MenuItem value={item.CatValue} key={index}>
                {item.CatDesc}
              </MenuItem>
            ))}
          </CustomizedSelect>
        </div>

        <div className="input-margin">
          <div className="input-name input-integrated-label">
            Switch In Scheme
          </div>
          <IntegrationReactSelect
            suggestions={switchInSchemes.map((item) => ({
              label: item.fm_schdesc,
              value: item,
            }))}
            label="Fund"
            handleChange={this.handleSwitchInSchemeChange}
            value={switchInScheme.value}
            placeholder="Select In Scheme"
            disabled={!category.value}
            inputRef={(ele) => (this.switchInScheme = ele)}
            isError={switchInScheme.isError}
            errorMessage={switchInScheme.errorMessage}
          />
        </div>

        <div className="input-margin">
          <Input
            name="ARN Code"
            bordercolor="#a6a6a6"
            value={arnCode.value.split("-")[1]}
            disabled={true}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Sub ARN Code"
            type="number"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            disabled={!fund.value}
            isShowError={subArnCode.isError}
            errorMessage={subArnCode.errorMessage}
            value={subArnCode.value}
            onBlur={
              !!fund.value ? this.validateBrokerCode(fund.value.value.Fund) : ""
            }
            onChange={this.changeValue("subArnCode")}
          />
        </div>
        <div className="input-margin">
          <Input
            name="Sub Broker Code"
            onKeyDown={(evt) =>
              (evt.key === "." || evt.key === "-") && evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            value={subBrokerCode.value}
            onChange={this.changeValue("subBrokerCode")}
          />
        </div>

        <div className="input-field-container">
          <div className="input-name">EUIN</div>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={radioValue.value}
              style={{ flexDirection: "row" }}
              onChange={this.changeValue("radioValue")}
            >
              <div className="investor-radio-button">
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#007ac8" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">YES</div>
              </div>
              <div className="investor-radio-button">
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#007ac8" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">NO</div>
              </div>
            </RadioGroup>
          </FormControl>
        </div>

        {radioValue.value === "yes" ? (
          // <div className="input-margin">
          //   <IntegrationReactSelect
          //     suggestions={euinList.map((item) => ({
          //       label: item.abm_agent,
          //       value: item.abm_agent,
          //     }))}
          //     label="Fund"
          //     handleChange={this.changeEuin}
          //     errorMessage={euinNo.errorMessage}
          //     value={euinNo.value}
          //     disabled={!euinList.length}
          //     placeholder="Select EUIN"
          //     inputRef={(ele) => (this.euinField = ele)}
          //     isError={euinNo.isError}
          //   />
          // </div>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 15,
              }}
            >
              <div
                className="investor-input-div"
                style={{ border: "1px black solid", height: "50px" }}
              >
                <SearchIcon className="investor-input-searchicon" />
                <InputBase
                  value={euinNo.value}
                  placeholder="Type here"
                  className="investor-input-inputbase"
                  onChange={(e) =>
                    this.setState({
                      euinNo: { value: e.target.value },
                      openeuin: true,
                    })
                  }
                />
              </div>
            </div>
            {euinList.length > 0 && this.state.openeuin && (
              <div className="dataResult">
                {euinList &&
                  euinList
                    .filter((ele) =>
                      ele.abm_agent
                        .toLowerCase()
                        .includes(euinNo.value.toLowerCase())
                    )
                    .map((ele) => (
                      <div>
                        <p
                          onClick={() => this.euinitem(ele)}
                          className="euin-item"
                        >
                          {ele.abm_agent}
                        </p>
                      </div>
                    ))}
              </div>
            )}
            {this.state.erroreuin && !this.state.euinNo.value && (
              <div style={{ color: "red" }}>Euin Declaration is mandatory</div>
            )}
          </div>
        ) : (
          <div className="euin-text">
            I/We hereby confirm that the EUIN box has been intentionally left
            the blank by me/us as this is an 'execution-only' transaction
            without any interaction or advice by any personnel of the above
            distributor or notwithstanding the advice of in-appropriateness,if
            any provided by any personnel of the distributor and the distributor
            has not charged any advisory fees on this transaction
          </div>
        )}

        <div className="input-name">Switch Type</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Partial"
            width={150}
            active={switchType === PARTIAL}
            onClick={this.changeSwitchType(PARTIAL)}
          />
          <Debtbutton
            buttontitle="Full"
            width={150}
            active={switchType === FULL}
            onClick={this.changeSwitchType(FULL)}
          />
        </div>

        {switchType !== FULL ? (
          <>
            <div className="input-name">Switch Mode</div>
            <div className="radio-buttons-div">
              <Debtbutton
                buttontitle="Units"
                width={150}
                active={switchMode === UNITS}
                onClick={this.changeSwitchMode(UNITS)}
              />
              <Debtbutton
                buttontitle="Amount"
                disabled={switchType === FULL ? true : false}
                width={150}
                active={switchMode === AMOUNT}
                onClick={this.changeSwitchMode(AMOUNT)}
              />
            </div>
          </>
        ) : null}

        <Input
          name="Switch Value (INR/UNITS)"
          type="number"
          bordercolor="#a6a6a6"
          onKeyDown={(evt) =>
            (evt.key === "e" || evt.key === "-") && evt.preventDefault()
          }
          errorMessage={amount.errorMessage}
          isShowError={amount.isError}
          disabled={switchType === FULL ? true : false}
          onChange={(event) => this.handleSwitchValueChange(event)}
          value={amount.value}
          inputref={(ele) => (this.amountField = ele)}
        />

        <div className="trantype-button-view">
          <Signbutton
            buttontitle="Add to cart"
            onClick={() => this.onButtonClick(`${addToCart}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
          <span className="addtocart-btn" />
          <Signbutton
            buttontitle="Submit"
            onClick={() => this.onButtonClick(`${SUBMIT}`)}
            width={240}
            border={"1px solid #007CC5"}
            texttransform={true}
          />
        </div>

        <AddToCartStatusModal
          closeModal={this.close}
          open={this.state.openDialog}
          image={"/images/cart_success.svg"}
          btn_one={"Go to cart"}
          btn_two={"Add more"}
          pan={this.props.investorData.PAN}
          onAddTransaction={() =>
            this.props.history.push("/cart/add-transaction/switch", {
              pan: this.props.investorData.PAN,
            })
          }
          message={`Transaction has been added to cart successfully with the reference number ${this.state.ihno} and bulk-order ID ${this.state.cartId}`}
          ihno={this.state.ihno}
          cartId={this.state.cartId}
        />
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      investorData,
      communicationDetails,
      isCartUser,
    } = authReducer;
    const { euinList, switchDetails = {} } = transactions;
    return {
      isCartUser,
      fundList,
      token,
      userId,
      euinList,
      switchDetails,
      investorData,
      communicationDetails,
    };
  },
  {
    validateSubBroker,
    getNewPurchaseFundList,
    getOtherSchemes,
    setSwitchDetails,
    getAssetClasses,
    getRedemptionPaymentDetails,
    switchTransaction,
    addItemsToCart,
    getCartItemsList,
  }
)(switchCmponent);
